import './styles.scoped.css'
import {Link, useLocation} from 'react-router-dom'
import {Chip} from '@mui/material'
import {Business} from '@mui/icons-material'
import {careviahLogo} from '../../assets'

const menuItems = [{label: 'Organizations', icon: <Business />, path: '/admin'}]

export default () => {
    const location = useLocation()

    const isActive = path => location.pathname.startsWith(path)

    return (
        <div className="container">
            <div className="logo-row">
                <Link to="/admin">
                    <img src={careviahLogo} height={30} />
                </Link>
                <Chip label="ADMIN" size="small" className="admin-chip" />
            </div>
            <br />
            {menuItems.map(({label, icon, path}) => (
                <Link key={label} to={path} className={`item ${isActive(path) ? 'active' : ''}`}>
                    <div className="icon">{icon}</div>
                    <div className="item-label">{label}</div>
                </Link>
            ))}
        </div>
    )
}
